import React from 'react';

import {withI18n} from 'spa/Components/Context';

import ProgressiveImage from 'spa/Components/ProgressiveImage';

import 'spa/styles/home.less';
import './partner-treatments.less';

@withI18n
class PartnerTreatments extends React.Component {
  render() {
    const {i18n} = this.context;

    return (
      <div className="home-content-section home-number-one-section home-content-section--no-padding-bottom partner-treatments row">
        <h2 className="typography--section-heading typography--centered partner-treatments__title">
          {i18n._x('Partner treatments by', 'Partner treatments section title')}
        </h2>
        <div className="partner-treatments__partner-container container">
          <div className="partner-treatments__partner-element">
            <p className="partner-treatments__partner-img-wrapper">
              <ProgressiveImage
                className="partner-treatments__partner-image partner-treatments__partner-image--short"
                lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,q_15,e_blur:2000/v1644314282/b2c-art/home-2022/dermalogica.png"
                highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,h_30/v1644314282/b2c-art/home-2022/dermalogica.png"
                highResImg2x="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,h_60/v1644314282/b2c-art/home-2022/dermalogica.png"
                alt={i18n._x('Dermalogica logo', 'Partner image alt text in the homepage')}
              />
            </p>
          </div>
          <div className="partner-treatments__partner-element partner-treatments__partner-element--tall">
            <p className="partner-treatments__partner-img-wrapper">
              <ProgressiveImage
                className="partner-treatments__partner-image partner-treatments__partner-image--tall"
                disableWebp
                lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/q_15,e_blur:2000/v1644314223/b2c-art/home-2022/gaia.png"
                highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,h_60/v1644314223/b2c-art/home-2022/gaia.png"
                highResImg2x="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,h_120/v1644314223/b2c-art/home-2022/gaia.png"
                alt={i18n._x('Gaia Guru logo', 'Partner image alt text in the homepage')}
              />
            </p>
          </div>
          <div className="partner-treatments__partner-element partner-treatments__partner-element--tall">
            <p className="partner-treatments__partner-img-wrapper">
              <ProgressiveImage
                className="partner-treatments__partner-image  partner-treatments__partner-image--tall"
                disableWebp
                lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/q_15,e_blur:2000/v1644314288/b2c-art/home-2022/thera.png"
                highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,h_60/v1644314288/b2c-art/home-2022/thera.png"
                highResImg2x="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,h_120/v1644314288/b2c-art/home-2022/thera.png"
                alt={i18n._x('Theragun logo', 'Partner image alt text in the homepage')}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default PartnerTreatments;



// WEBPACK FOOTER //
// ./spa/Pages/Home2020/digital/PartnerTreatments.jsx